// 判断是否在localstorage 还是在 cookie 中，并进行处理
var cookie = require("./cookie.js")


function setItem(key, value, time){
  if(typeof(localStorage)!="undefined"){
    return localStorage.setItem(key,value);
  }else{
    var domain = window.location.hostname;
    return cookie.set(key,value,time,domain);
  }
}


function getItem(key){
  if(typeof(localStorage)!="undefined"){
    return localStorage.getItem(key);
  }else{
    return cookie.get(key)
  }
}

function delItem(key,options){
  if(typeof(localStorage)!="undefined"){
    return localStorage.removeItem(key);
  }else{
    return cookie.removeCookie(key, options)
  }

}


module.exports={
  setItem: setItem,
  getItem: getItem,
  delItem: delItem
}


//////////////////
// WEBPACK FOOTER
// ./src/module/helper/storage.js
// module id = 14
// module chunks = 0